import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Report,
  ReportContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-report',
  template: Report.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Report.height;
  @Input() public viewBox: string = getSVGViewBox(Report.viewBox);
  @Input() public width: number | string = Report.width;
  @Input()
  public set context(ctx: ReportContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: ReportContext = Report.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = ReportComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Report.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
